import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';

class LaDMonitor extends Component {
    componentDidMount() {
    }
    render() {
        return (
            <Body>
                <Title>Life and Death monitoring</Title>
                <Contents>
                    CHECK
                </Contents>
            </Body>
        );
    }
}
const mapStateToProps = (store, ownProps) => {
    return {
        permission: store.login.user.permission,
        loading: store.loading.loading,
        afterLoadMessage: store.loading.message,
        loadResult: store.loading.state,
    }
};

const connectedLaDMonitor = connect(mapStateToProps)(LaDMonitor);
export { connectedLaDMonitor as LaDMonitor };

const Body = styled.div`
    padding: 0 20px;
`;
const Title = styled.h1`
    font-size: 24px;
    font-weight: bold;
`;
const Contents = styled.div`
`;
